__turbopack_context__.v({
  "wrapper": "MoneyPostBreadcrumbs-module__XuFpSG__wrapper",
});
